import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ClientInfoForm = ({ formData, onFormChange, onSubmit, isSubmitting }) => {
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.firstName?.trim()) {
      newErrors.firstName = 'First name is required';
    }

    if (!formData?.lastName?.trim()) {
      newErrors.lastName = 'Last name is required';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/?.test(formData?.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData?.phone?.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^\+?[\d\s\-\(\)]{10,}₹/?.test(formData?.phone?.replace(/\s/g, ''))) {
      newErrors.phone = 'Please enter a valid phone number';
    }

    if (!formData?.location?.trim()) {
      newErrors.location = 'Location is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    onFormChange({ ...formData, [name]: value });
    
    // Clear error when user starts typing
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onSubmit();
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="mb-6">
        <h3 className="text-lg font-heading font-semibold text-primary mb-2">
          Contact Information
        </h3>
        <p className="text-muted-foreground font-body">
          Please provide your details so we can confirm your booking
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Name Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="First Name"
            type="text"
            name="firstName"
            value={formData?.firstName || ''}
            onChange={handleInputChange}
            placeholder="Enter your first name"
            error={errors?.firstName}
            required
          />
          
          <Input
            label="Last Name"
            type="text"
            name="lastName"
            value={formData?.lastName || ''}
            onChange={handleInputChange}
            placeholder="Enter your last name"
            error={errors?.lastName}
            required
          />
        </div>

        {/* Contact Fields */}
        <Input
          label="Email Address"
          type="email"
          name="email"
          value={formData?.email || ''}
          onChange={handleInputChange}
          placeholder="your.email@example.com"
          description="We'll send booking confirmation to this email"
          error={errors?.email}
          required
        />

        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          value={formData?.phone || ''}
          onChange={handleInputChange}
          placeholder="+1 (555) 123-4567"
          description="We may call to confirm details"
          error={errors?.phone}
          required
        />

        {/* Location */}
        <Input
          label="Preferred Location"
          type="text"
          name="location"
          value={formData?.location || ''}
          onChange={handleInputChange}
          placeholder="Studio, your location, or outdoor venue"
          description="Where would you like the session to take place?"
          error={errors?.location}
          required
        />

        {/* Special Requests */}


        {/* Marketing Consent */}


      </form>
    </div>
  );
};

export default ClientInfoForm;